import request from '#/utils/request';
import { keysToCamel } from '#/api/adapters/wireCase';

/**
 * 工單維修單列表（cursor 分頁，`created_at DESC, id DESC`）。
 * GET `/mom/work-order-repair?work_order_id=&limit=&cursor=`
 * `nextCursor` 原樣傳回下一頁；null 表示沒有下一頁。
 */
export async function fetchWorkOrderRepairList({ workOrderId, limit, cursor } = {}) {
  const params = new URLSearchParams();
  params.set('work_order_id', workOrderId);
  if (limit) {
    params.set('limit', String(limit));
  }
  if (cursor) {
    params.set('cursor', cursor);
  }
  const { data: raw } = await request.get('/mom/work-order-repair', { params });
  return {
    message: raw.message,
    route: raw.route,
    data: keysToCamel(raw.list ?? []),
    nextCursor: raw.next_cursor ?? null,
  };
}
